import { Icon } from '@orbita-ui/core';
import { ReactNode } from 'react';
import { ThemePrisma } from '@orbita-ui/brand';
import styled from 'styled-components';

type StateModal = 'error' | 'info' | 'success' | 'warning';

const StyledModal = styled.div`
  display: flex;
  flex-direction: column;
  -webkit-box-align: center;
  align-items: center;
  gap: 24px;
  width: 100%;

  div.body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: 100%;

    .header-text {
      color: rgb(31, 41, 51);
      font-family: Inter, sans-serif;
      font-size: 1.125rem;
      letter-spacing: -0.01em;
      line-height: 1.5rem;
      font-weight: 600;
    }

    .body-text {
      color: rgb(62, 76, 89);
      font-family: Inter, sans-serif;
      font-size: 0.875rem;
      letter-spacing: 0em;
      line-height: 1.5rem;
      font-weight: 400;
    }
  }

  div.footer {
    width: 100%;
    display: flex;
    flex-direction: row;
    -webkit-box-pack: end;
    justify-content: flex-end;
    gap: 16px;
  }

  div.icon-container {
    display: flex;
    flex-direction: row;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    padding: 8px;
    width: 48px;
    height: 48px;
    box-sizing: border-box;

    border-radius: 16px;
    margin-bottom: 8px;
    margin-top: -24px;

    svg {
      width: 32px;
      height: 32px;
    }

    &.error {
      background: ${ThemePrisma.colors.red[1]};
      svg {
        color: ${ThemePrisma.colors.red[5]};
      }
    }

    &.success {
      background: ${ThemePrisma.colors.green[1]};
      svg {
        color: ${ThemePrisma.colors.green[5]};
      }
    }

    &.info {
      background: ${ThemePrisma.colors.blue[1]};
      svg {
        color: ${ThemePrisma.colors.blue[4]};
      }
    }

    &.warning {
      background: ${ThemePrisma.colors.yellow[1]};
      svg {
        color: ${ThemePrisma.colors.yellow[4]};
      }
    }
  }
`;

function getStateIcon(state: StateModal) {
  switch (state) {
    case 'error':
      return <Icon name="WarningTriangleIcon" />;
    case 'info':
      return <Icon name="InfoIcon" />;
    case 'success':
      return <Icon name="CheckSquareIcon" />;
    case 'warning':
      return <Icon name="WarningIcon" />;
  }
}

export const BaseModal = ({
  state,
  title,
  body,
  footer,
}: {
  state?: StateModal;
  title?: ReactNode;
  body?: ReactNode;
  footer?: ReactNode;
}) => {
  return (
    <StyledModal>
      <div className="body">
        {state && <div className={`icon-container ${state}`}>{getStateIcon(state)}</div>}
        <div className="header-text">{title}</div>
        <div className="body-text">{body}</div>
      </div>
      <div className="footer">{footer}</div>
    </StyledModal>
  );
};
